export var SLOT_NAME_APPEND = 'append';
export var SLOT_NAME_BUTTON_CONTENT = 'button-content';
export var SLOT_NAME_DEFAULT = 'default';
export var SLOT_NAME_DESCRIPTION = 'description';
export var SLOT_NAME_FIRST = 'first';
export var SLOT_NAME_FOOTER = 'footer';
export var SLOT_NAME_HEADER = 'header';
export var SLOT_NAME_LABEL = 'label';
export var SLOT_NAME_LEAD = 'lead';
export var SLOT_NAME_PREPEND = 'prepend';
export var SLOT_NAME_TEXT = 'text';
export var SLOT_NAME_TITLE = 'title';